import { Copy, Dna, Eye, PenLine, Play, Trash } from "lucide-react";
import React, { useState } from "react";

export default function GameCard({ data, onDelete, onEdit, onPreview ,onUpdate,onCopy}) {
    const [isEnable, setIsEnable] = useState(data.status);
  
  return (
    <div className="flex flex-col w-full rounded-lg border border-gray-200 dark:border-slate-400 bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl p-[6px] hover:shadow-lg transition-shadow duration-300 ">
      <div className="flex items-start justify-start ">
        {/* Icon */}
        <div
          className="relative w-24 h-24 rounded-lg overflow-hidden cursor-pointer group"
          onClick={onPreview}
        >
          {/* Image */}
          <img
            src={data.icon}
            alt={data.title}
            className="w-full h-full object-cover transition-all duration-300 group-hover:blur-sm group-hover:scale-110"
          />
          {/* Dark Overlay */}
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300" />
          {/* Play Button */}
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-white text-slate-900 shadow-lg">
              <Play size={20} fill="currentColor" />
            </div>
          </div>
        </div>

      
        {/* Content */}
        <div className="flex flex-col flex-1 px-2 ">
          <span className="text-sm font-semibold text-slate-700 dark:text-slate-100">
            {data.title}
          </span>

          <div className="flex items-center space-x-1 mt-1">
            <Dna className="text-slate-700 dark:text-slate-300" size={14} />
            <span className="text-xs font-semibold text-slate-700 dark:text-slate-400">
              Genre :
            </span>
            <span className="text-xs text-slate-700 dark:text-slate-400 line-clamp-1">
              {data.genre}
            </span>
          </div>

          <span className="text-xs mt-1 text-slate-700 dark:text-slate-500 line-clamp-2">
            {data.description}
          </span>
        </div>
      </div>
      {/* Action Buttons - Always Bottom */}
      <div className=" mt-2 flex items-start justify-start ">
        <div
         
          className="flex items-center space-x-1 cursor-pointer text-blue-500 mr-auto"
        >
        <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={isEnable}
              onChange={(e) => {
                const value = e.target.checked;
                setIsEnable(value);
                onUpdate(value);
              }}
            />
            <div className="w-10 h-5 bg-gray-300 dark:bg-gray-700 rounded-full peer peer-checked:bg-blue-600 transition-all after:content-[''] after:absolute after:w-4 after:h-4 after:bg-white after:rounded-full after:top-[2px] after:left-[2px] peer-checked:after:translate-x-5 after:transition-all"></div>
          </label>
        </div>

        <Copy
          onClick={onCopy}
          className="cursor-pointer text-blue-500 hover:text-blue-700 mr-4"
          size={16}
        /> 
        <PenLine
          onClick={onEdit}
          className="cursor-pointer text-green-500 hover:text-green-700 mr-4"
          size={16}
        />

        <Trash
          onClick={onDelete}
          className="cursor-pointer text-red-500 hover:text-red-700"
          size={16}
        />
      </div>
    </div>
  );
}
